import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { HomePage } from './pages/home/home';

import { LoginComponent } from './pages/login';

import { AuthenticatedGuard } from '@ews/users-management';
import { VisitDetailsPage } from './pages/visit-details/visit-details.page';
import { QuestionnairePage } from './pages/questionnaire/questionnaire.page';
import { QuestionPhotosPage } from './pages/question-photos/question-photos.page';
import { QuestionCommentsPage } from './pages/question-comments/question-comments.component';
import { VisitDayPage } from './pages/visit-day/visit-day.page';
import { VisitDayDetailsPage } from './pages/visit-day-details/visit-day-details.page';
import { NotesPage } from './pages/notes/notes.component';
import { ChatsPage } from './pages/chats/chats.component';
import { AreaPage } from './pages/area/area.component';
import { AreaMapPage } from './pages/area-map/area-map.component';
import { AreaMonitorPage } from './pages/area-monitor/area-monitor.component';
import { ScannerComponent } from './shared-components/components/scanner/scanner.component';
import { ActionPage } from './pages/action/action.component';
import { NCComponent } from './pages/nc/nc.component';
import { NonconformityPage } from './pages/nonconformity/nonconformity.component';
import { CheckStockPageComponent } from './pages/check-stock-page/check-stock-page.component';
import { ChatPage } from './pages/chat/chat.page';

const routes: Routes = [
  {
    path: '',
    canActivate: [AuthenticatedGuard],
    //canActivate: [AuthGuard],
    //pathMatch: 'full',
    children: [
      { path: '', redirectTo: '/login', pathMatch: 'full' },
      {
        path: 'home',
        component: HomePage,
      },
      { path: 'notes', component: NotesPage },
      { path: 'chats', component: ChatsPage },
      { path: 'nc', component: NCComponent },
      {
        path: 'check-stock',
        component: CheckStockPageComponent,
      },
      {
        path: 'chat/:chatId',
        component: ChatPage,
      },
      {
        path: 'visitdetails/:id',
        component: VisitDetailsPage,
      },
      {
        path: 'visitday/:date/:dayId',
        component: VisitDayPage,
      },
      {
        path: 'visitday/details/:date/:id/:dayId',
        component: VisitDayDetailsPage,
      },
      {
        path: 'area/:date/:id/:dayId/:areaid',
        component: AreaPage,
      },
      {
        path: 'action',
        component: ActionPage,
      },
      {
        path: 'nonconformity',
        component: NonconformityPage,
      },
      {
        path: 'area/map/:date/:id/:dayId/:areaid',
        component: AreaMapPage,
      },
      {
        path: 'area/monitor/:date/:id/:dayId/:areaid/:monitorId',
        component: AreaMonitorPage,
      },
      {
        path: 'questionnaire/:customFormId/:parentObject/:id',
        component: QuestionnairePage,
      },
      {
        path: 'photos/:answerId/:maxNumberOfPhotos/:categoryKey/:question/:photosCount/:customFormId/:parentObject/:id',
        component: QuestionPhotosPage,
      },
      {
        path: 'comments/:answerId/:categoryKey/:question/:customFormId/:parentObject/:id',
        component: QuestionCommentsPage,
      },

      {
        path: 'scanner/:instanceId/:date/:id/:dayId/:areaid',
        component: ScannerComponent,
      },
    ],
  },
  {
    path: 'login',
    component: LoginComponent,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
